// activeSafetyForms/nearMiss/slice.js

import { activeNearMissInitialState } from "./activeSafetyFormsNearMissState";
import { makeActiveNearMissActions } from "./activeSafetyFormsNearMissActions";

export const createActiveNearMissSlice = (set, get) => ({
  activeNearMiss: activeNearMissInitialState,
  activeNearMissActions: Object.freeze(makeActiveNearMissActions(set, get)),
});
